/**
 * Utility to remove all demo data from Firestore
 * This can be called from the browser console or imported in a component
 */

import { vehiclesService, invoicesService } from '../services/firestoreService';
import { auth } from '../firebase/config';

/**
 * Remove all vehicles from Firestore
 */
export const removeAllVehicles = async () => {
  try {
    const isAuthenticated = auth.currentUser !== null;
    
    if (!isAuthenticated) {
      throw new Error('You must be logged in to remove vehicles');
    }
    
    // Delete from Firestore using batch delete
    console.log('🗑️  Deleting all vehicles from Firestore...');
    const deletedCount = await vehiclesService.deleteAll();
    console.log(`✅ Deleted ${deletedCount} vehicles from Firestore`);
    
    return { success: true, deleted: deletedCount };
  } catch (error) {
    console.error('❌ Error removing vehicles:', error);
    throw error;
  }
};

/**
 * Remove all invoices from Firestore
 */
export const removeAllInvoices = async () => {
  try {
    const isAuthenticated = auth.currentUser !== null;
    
    if (!isAuthenticated) {
      throw new Error('You must be logged in to remove invoices');
    }
    
    // Delete from Firestore using batch delete
    console.log('🗑️  Deleting all invoices from Firestore...');
    const deletedCount = await invoicesService.deleteAll();
    console.log(`✅ Deleted ${deletedCount} invoices from Firestore`);
    
    return { success: true, deleted: deletedCount };
  } catch (error) {
    console.error('❌ Error removing invoices:', error);
    throw error;
  }
};

/**
 * Remove all demo data (vehicles and invoices)
 */
export const removeAllDemoData = async () => {
  try {
    console.log('🗑️  Starting demo data removal...');
    
    const vehicleResult = await removeAllVehicles();
    const invoiceResult = await removeAllInvoices();
    
    console.log('✅ Demo data removal complete!');
    console.log(`   - Vehicles deleted: ${vehicleResult.deleted}`);
    console.log(`   - Invoices deleted: ${invoiceResult.deleted}`);
    
    // Reload the page to see changes
    if (typeof window !== 'undefined') {
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    }
    
    return {
      success: true,
      vehicles: vehicleResult.deleted,
      invoices: invoiceResult.deleted
    };
  } catch (error) {
    console.error('❌ Error removing demo data:', error);
    throw error;
  }
};

// Make it available globally for easy console access
if (typeof window !== 'undefined') {
  window.removeAllDemoData = removeAllDemoData;
  window.removeAllVehicles = removeAllVehicles;
  window.removeAllInvoices = removeAllInvoices;
}

